import BranchesAPI from '../../api/branches';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

const readStoredId = () => {
  const raw = LocalStorage.get(LOCAL_STORAGE_KEYS.ACTIVE_BRANCH_ID);
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? id : null;
};

export const state = {
  records: [],
  activeBranchId: readStoredId(),
  uiFlags: { isFetching: false },
};

export const getters = {
  getBranches: _state => _state.records,
  getActiveBranchId: _state => _state.activeBranchId,
  getActiveBranch: _state =>
    _state.records.find(b => b.id === _state.activeBranchId) || null,
  getBranchesUIFlags: _state => _state.uiFlags,
};

export const actions = {
  async get({ commit, state: _state, rootGetters }) {
    commit('SET_BRANCH_UI_FLAG', { isFetching: true });
    try {
      const response = await BranchesAPI.get();
      const records = response.data || [];
      commit('SET_BRANCHES', records);

      const stored = _state.activeBranchId;
      const storedExists = stored && records.some(b => b.id === stored);
      if (!storedExists && records.length > 0) {
        // Primer login (sin localStorage válido): usar primary_branch_id del usuario
        // si está seteado; si no, fallback al Personal o la primera disponible.
        const currentUser = rootGetters.getCurrentUser;
        const primaryId = currentUser?.primary_branch_id;
        const primary = primaryId ? records.find(b => b.id === primaryId) : null;
        const target = primary || records.find(b => b.is_personal) || records[0];
        commit('SET_ACTIVE_BRANCH_ID', target.id);
        LocalStorage.set(LOCAL_STORAGE_KEYS.ACTIVE_BRANCH_ID, target.id);
      }
    } finally {
      commit('SET_BRANCH_UI_FLAG', { isFetching: false });
    }
  },

  setActive({ commit }, branchId) {
    const id = Number(branchId);
    commit('SET_ACTIVE_BRANCH_ID', id);
    LocalStorage.set(LOCAL_STORAGE_KEYS.ACTIVE_BRANCH_ID, id);
  },

  async create({ commit }, payload) {
    const response = await BranchesAPI.create({ branch: payload });
    commit('ADD_BRANCH', response.data);
    return response.data;
  },

  async update({ commit }, { id, ...payload }) {
    const response = await BranchesAPI.update(id, { branch: payload });
    commit('UPDATE_BRANCH', response.data);
    return response.data;
  },

  async delete({ commit }, id) {
    await BranchesAPI.delete(id);
    commit('REMOVE_BRANCH', id);
  },

  async uploadLogo({ commit }, { id, file }) {
    const data = await BranchesAPI.uploadLogo(id, file);
    commit('UPDATE_BRANCH', data);
    return data;
  },

  async removeLogo({ commit }, id) {
    const data = await BranchesAPI.removeLogo(id);
    commit('UPDATE_BRANCH', data);
    return data;
  },
};

export const mutations = {
  SET_BRANCHES(_state, records) {
    _state.records = records;
  },
  SET_ACTIVE_BRANCH_ID(_state, id) {
    _state.activeBranchId = id;
  },
  SET_BRANCH_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  ADD_BRANCH(_state, record) {
    _state.records = [..._state.records, record];
  },
  UPDATE_BRANCH(_state, record) {
    const idx = _state.records.findIndex(b => b.id === record.id);
    if (idx === -1) return;
    const next = [..._state.records];
    next[idx] = record;
    _state.records = next;
  },
  REMOVE_BRANCH(_state, id) {
    _state.records = _state.records.filter(b => b.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
